export default "__VITE_ASSET__4106b3e8__"